/**
 * /library/folders — redirect to the documents workspace.
 *
 * #223 — the documented IA exposes `/library/folders` as a
 * separate page, but folder management is embedded in the
 * `/library/documents` left-rail (KbSidebar). Deep links here
 * route users to the workspace where folders live, with the
 * full sidebar visible.
 *
 * 2026-05-12 browser audit P1 #6 — B2 found this and the sibling
 * /library/wiki "redirect silently" because the previous Navigate
 * component rendered the Documents view but never rewrote the URL.
 * The audit screenshot showed /library/folders in the URL bar with
 * the Documents tab highlighted — indistinguishable from a missing
 * redirect. Switch to a `beforeLoad` redirect (server-side route
 * compat, like /studio/templates) so the URL bar shows
 * /library/documents after navigation and the audit no longer
 * reports a layout-collapse defect.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/library/folders')({
  beforeLoad: () => {
    throw redirect({ to: '/library/documents', replace: true, code: 308 });
  },
});
